import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        start: 'Start',
        data: 'Data',
        hello: 'Hello',
        listOne:
          'To test the app, there is a test account where you only have to enter the word "test" in lower case as a username and password.',
        listTwo:
          'Under "Insulin factor" and "Correction factor" the respective factors must first be created.',
        listThree:
          'In the next step, under "Start", you can now start entering the current the current blood glucose value and the carbohydrates you want to consume. you would like to consume.',
        listFour:
          'Then just click on "Confirm" and the amount of insulin to be injected is displayed. The calculation is done automatically taking into account the time of day and thus selects the appropriate factor.',
        listFive:
          'In the "Data" area, you can display the data used and saved and also export it as a "PDF".',
        bloodsugar: 'Bloodsugar',
        bloodsugarlevel: 'Blood glucose level',
        currentbloodglucosevalue: ' Current blood glucose value',
        carbohydrates: 'Carbohydrates',
        howmanyKhd65g: 'How many Khd 65g',
        insulin: 'Insulin',
        factor: 'Factor',
        whichinsulin1: 'Which insulin',
        whichinsulin2: 'is taken',
        chooseinsulin: 'Choose insulin',
        confirm: 'confirm',
        injectunits: 'Inject units',
        ofinsulin: 'of insulin',
        daytimefactor: 'Daytime factor',
        insulinfactor: 'Insulin factor',
        correction: 'Correction',
        saved: 'Saved',
        factormorning: 'Morning factor',
        factornoon: 'Lunch factor',
        factorevening: 'Evening factor',
        factorlate: 'Late factor',
        enter: 'Enter',
        save: 'Save',
        createinsulinfactor: 'Create insulin factor',
        createcorrectionfactor: 'Create correction factor',
        correctionfactor: 'Correction factor',
        correctionfactormorning: 'Correction factor morning',
        correctionfactornoon: 'Correction factor noon',
        correctionfactorevening: 'Correction factor evening',
        correctionfactorlate: 'Correction factor late',
        usedinsulin: 'Used insulin',
        injectedinsulin: 'Injected insulin',
        quantity: 'Quantity',
        saveddatafrom: 'Saved data from',
        createdon: 'Created on',
        date: 'Date',
        pdfSaved: 'PDF saved',
        storedvalues: 'Stored values',
        contact: 'Contact',
        deleteSelected: 'Delete selected',
        dataSaved: 'Data saved!',
        cancel: 'Cancel',
        yesDelete: 'Yes delete',
        sure:'Are you sure you want to delete all data?',
        yesSave: 'Yes, save',
        confirmData: 'Confirm data',
        export: 'PDF',
        exportNow: 'Export now!',
        exporting: 'Exporting...',
        deleteEntryTitle: 'Delete entry',
        deleteSelectedEntriesTitle: 'Delete selected entries',
        deleteEntryDescription: 'Are you sure you want to delete this entry?',
        deleteSelectedEntriesDescription: 'Are you sure you want to delete the selected entries?',
        selectDateRange: 'Select date',
        exportFilteredData: 'Export filtered data',
        exportAllData: 'Export all data',
        startDate: 'Start date',
        endDate: 'End date',
        selectedCount: 'Selected',
        totalCount: 'Total',
        changeDateRange: 'Change date range',
        deselectAll: 'Deselect everyone',
        selectAll: 'Select everything',
        deleteUserData: 'Delete all user data',
        logout: 'logout',
      },
    },
    de: {
      translation: {
        start: 'Start',
        data: 'Daten',
        hello: 'Hallo',
        listOne:
          'Zum Testen der App gibt es einen Testaccount, bei dem man als Username und Passwort nur das Wort "test" kleingeschrieben eingeben muss.',
        listTwo:
          'Unter "Insulin Faktor" und "Korrektur Faktor" müssen erst die jeweiligen Faktoren angelegt werden.',
        listThree:
          'Im nächsten Schritt kann jetzt unter "Start" mit der Eingabe des aktuellen Blutzuckerwertes und der Kohlenhydrate, die man zu sich nehmen möchte, begonnen werden.',
        listFour:
          'Im Anschluss klickt man nur noch auf "Bestätigen" und man bekommt die zu spritzende Insulin Menge angezeigt. Die Berechnung erfolgt automatisch unter Einbezug der Tageszeit und wählt so den entsprechenden Faktor.',
        listFive:
          'Im Bereich "Daten" kann man sich die verwendeten und gespeicherten Daten anzeigen lassen und auch als "PDF" exportieren.',
        bloodsugar: 'Blutzucker',
        bloodsugarlevel: 'Blutzuckerwert',
        currentbloodglucosevalue: 'aktueller Blutzuckerwert',
        carbohydrates: 'Kohlenhydrate',
        howmanyKhd65g: 'wieviele Khd 65g',
        insulin: 'Insulin',
        factor: 'Faktor',
        whichinsulin1: 'Welches Insulin ',
        whichinsulin2: 'wird genommen',
        chooseinsulin: 'Insulin wählen',
        confirm: 'bestätigen',
        injectunits: 'Einheiten',
        ofinsulin: 'Insulin spritzen',
        daytimefactor: 'Tageszeitfaktor',
        insulinfactor: 'Insulinfaktor',
        correction: 'Korrektur',
        saved: 'Gespeicherter',
        factormorning: 'Faktor morgens',
        factornoon: 'Faktor mittags',
        factorevening: 'Faktor abends',
        factorlate: 'Faktor spät',
        enter: 'eingeben',
        save: 'Speichern',
        createinsulinfactor: 'Insulinfaktor anlegen',
        createcorrectionfactor: 'Korrekturfaktor anlegen',
        correctionfactor: 'Korrekturfaktor',
        correctionfactormorning: 'Korrekturfaktor morgens',
        correctionfactornoon: 'Korrekturfaktor mittags',
        correctionfactorevening: 'Korrekturfaktor abends',
        correctionfactorlate: 'Korrekturfaktor spät',
        search: 'Suche',
        usedinsulin: 'Verwendetes Insulin',
        injectedinsulin: 'gespritzte Insulin',
        quantity: 'Menge',
        saveddatafrom: 'Gespeicherte Daten von',
        createdon: 'Erstellt am',
        date: 'Datum',
        pdfSaved: 'PDF gespeichert',
        storedvalues: 'Gespeicherte Werte',
        contact: 'Kontakt',
        deleteSelected: 'Markierte löschen',
        dataSaved: 'Daten gespeichert!',
        cancel: 'Abbrechen',
        yesDelete: 'Ja, löschen',
        sure:'Sicher, dass du alle Daten löschen möchtest?',
        yesSave: 'Ja, speichern',
        confirmData: 'Daten bestätigen',
        export: 'PDF',
        exportNow: 'Jetzt exportieren!',
        exporting: 'Exportiere...',
        deleteEntryTitle: 'Eintrag löschen',
        deleteSelectedEntriesTitle: 'Ausgewählte Einträge löschen',
        deleteEntryDescription: 'Möchten Sie diesen Eintrag wirklich löschen?',
        deleteSelectedEntriesDescription: 'Möchten Sie die ausgewählten Einträge wirklich löschen?',
        selectDateRange: 'Datum wählen',
        exportFilteredData: 'Gefilterte Daten exportieren',
        exportAllData: 'Alle Daten exportieren',
        startDate: 'Start Datum',
        endDate: 'End Datum',
        selectedCount: 'Markiert',
        totalCount: 'Gesammt',
        changeDateRange: 'Datumsbereich ändern',
        deselectAll: 'Alle abwählen',
        selectAll: 'Alle auswählen',
        deleteUserData: 'Alle Daten löschen',
        logout: 'Abmelden',
      },
    },
  },
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
